/**
 * @generated SignedSource<<6ed9797be759e375a531e38a2af48352>>
 * @relayHash 1cb037b815e517bd7984595b20d124af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID acb8b4b0c8e9ce55d652b28f502d52dd391de7c55bdb32f248dbeb8199940cbc

import type { ConcreteRequest } from 'relay-runtime';
export type PageTreeMacroAncestorsQuery$variables = {
  contentId: string;
};
export type PageTreeMacroAncestorsQuery$data = {
  readonly ptpage: {
    readonly id: string;
    readonly nearestAncestors: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
      } | null> | null;
    } | null;
  } | null;
};
export type PageTreeMacroAncestorsQuery = {
  response: PageTreeMacroAncestorsQuery$data;
  variables: PageTreeMacroAncestorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "ptpage",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "nearestAncestors",
        "plural": false,
        "selections": [
          {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PageTreeMacroAncestorsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageTreeMacroAncestorsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1cb037b815e517bd7984595b20d124af",
    "id": "acb8b4b0c8e9ce55d652b28f502d52dd391de7c55bdb32f248dbeb8199940cbc",
    "metadata": {},
    "name": "PageTreeMacroAncestorsQuery",
    "operationKind": "query",
    "text": "query PageTreeMacroAncestorsQuery($contentId:ID!){ptpage(id:$contentId){id,nearestAncestors{nodes{id}}}}"
  }
};
})();

(node as any).hash = "87b0f0557adb9a0866c0ecd4aae73da8";

export default node;
